module.exports = __webpack_public_path__ + "img/palestine,-state-of.4458efc2.svg";